import { render } from "./BlFormFieldTextarea.vue?vue&type=template&id=3db8632c&scoped=true"
import script from "./BlFormFieldTextarea.vue?vue&type=script&lang=js"
export * from "./BlFormFieldTextarea.vue?vue&type=script&lang=js"

import "./BlFormFieldTextarea.vue?vue&type=style&index=0&id=3db8632c&scoped=true&lang=css"

import exportComponent from "/tmp/7c12f39a-5a06-429e-8ff2-90249d9b2982/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db8632c"]])

export default __exports__